import React from 'react';

const Clients = () => {
    return (
        <div>
            <h2>客户端</h2>
        </div>
    );
};

export default Clients;